(function ($) {
	if ($(".politician-find-page").length > 0) {

		var getUrlParameter = function (name) {
			return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || "";
		};

		// Set state (+ filters from url)
		var state = {
			selectedParties: getUrlParameter("p") !== "" ? getUrlParameter("p").split(",") : [],
			selectedLocations: getUrlParameter("l") !== "" ? getUrlParameter("l").split(",") : [],
			selectedGroups: getUrlParameter("g") !== "" ? getUrlParameter("g").split(",") : [],
			onlyGroupLeaders: getUrlParameter("gl") !== "" ? getUrlParameter("gl") : "0",
			query: getUrlParameter("q").replace(/^\s+|\s+$/gm, "")
		};
		window.sk_politician_find_page_state = state;

		// Apply filters
		var filterToUrlTimeout;
		var filter = function () {
			$(".politician-find-page__link").show();
			$(".politician-find-page__letter-seperator").show();

			// Update URL
			if (history.replaceState) {

				var params = "";

				if (state.query !== "")
					params = params + "&q=" + state.query;

				if (state.selectedParties.length)
					params = params + "&p=" + state.selectedParties;

				if (state.selectedLocations.length)
					params = params + "&l=" + state.selectedLocations;

				if (state.selectedGroups.length)
					params = params + "&g=" + state.selectedGroups;

				if (state.onlyGroupLeaders === "1")
					params = params + "&gl=" + state.onlyGroupLeaders;

				if (params !== "")
					params = "?" + params.substr(1);

				clearTimeout(filterToUrlTimeout);
				filterToUrlTimeout = setTimeout(function () {
					var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + params;
					window.history.replaceState({ path: newUrl }, '', newUrl);
				}, 200);
			}

			// Search query
			if (state.query !== "") {
				var lowerCaseQuery = state.query.toLowerCase();
				var splitArray = lowerCaseQuery.trim().split(" ");

				splitArray.forEach(function (v, i) {
					$(".politician-find-page__link:not([data-title*='" + v + "'])").each(function () {
						$(this).hide();
					});
				});
			}

			// Close open politician info boxes when using filter
			$(".politician-find-page__link").removeClass("open");

			// Parties
			if (state.selectedParties.length > 0) {
				var show = [];

				state.selectedParties.forEach(function (party) {
					show.push("[data-party='" + party + "']");
				});

				notSelector = show.join(",");

				$(".politician-find-page__link:not(" + notSelector + ")").each(function () {
					$(this).hide();
				});
			}

			// Locations
			if (state.selectedLocations.length > 0) {
				var show = [];

				state.selectedLocations.forEach(function (party) {
					show.push("[data-location*='" + party + "']");
				});

				notSelector = show.join(",");

				$(".politician-find-page__link:not(" + notSelector + ")").each(function () {
					$(this).hide();
				});
			}

			// Groups
			if (state.selectedGroups.length > 0) {
				$(".politician-find-page__link").each(function () {
					var groups = $(this).data("groups");

					if (groups.length > 0) {



						if (!groups.some(function (r) { return state.selectedGroups.indexOf(r) >= 0 })) {
							// Hides politicians that is not member of selected groups
							$(this).hide();
						}
					}
					else {
						$(this).hide();
					}
				});
			}

			// Group leader
			if (state.onlyGroupLeaders === "1") {
				document.querySelectorAll(".politician-find-page__link").forEach(link => {
					const isGroupLeader = link.dataset.groupLeader === "1";
					if (!isGroupLeader) {
						link.style.display = "none";
					}
				});
			}

			// Show letter seperators for the visible links
			$(".politician-find-page__letter-seperator").hide();
			$(".politician-find-page__link:visible").each(function () {
				$(".politician-find-page__link-letter-collection[data-first-letter='" + $(this).data("first-letter") + "'] .politician-find-page__letter-seperator").show();
			});



			var totalLinks = $('.politician-find-page__link').length;
			var visibleLinks = $('.politician-find-page__link:visible').length;

			// Error messages
			if (visibleLinks <= 0 && totalLinks > 0) {
				$('.politician-find-page__links__noresult').addClass('politician-find-page__links__noresult--visible');
			} else if (totalLinks <= 0) {
				$('.politician-find-page__links__nolinks').addClass('politician-find-page__links__nolinks--visible');
			} else {
				$('.politician-find-page__links__noresult').removeClass('politician-find-page__links__noresult--visible');
				$('.politician-find-page__links__nolinks').removeClass('politician-find-page__links__nolinks--visible');
			}
			
			updateExcelExportForm();
		};


		// Update .js-export-to-excel-link with id to each visible politician
		let updateExcelExportForm = function () {
			let politicianIds = [];
			$('.politician-find-page__link:visible').each(function () {
				var id = $(this).data('id');
				if (id) {
					politicianIds.push(id);
				}
			});
			if (politicianIds.length > 0) {
				// #js-export-to-excel-ids is a hidden input field in the form - update with politician ids comma separated
				$('#js-export-to-excel-ids').val(politicianIds.join(','));
				$('.export-to-excel-form').show();
			}
			else {
				$('#js-export-to-excel-ids').val('');
				$('.export-to-excel-form').hide();
			}
		};
		updateExcelExportForm();

		// Update category filter state
		var updatePartyFilter = function () {
			$('.politician-find-page__party-checkbox:checked').each(function () {
				state.selectedParties.push($(this).val());
			});
			filter();
		};
		var updateGroupLeaderFilter = function () {
			$('.politician-find-page__group-leader-checkbox:checked').each(function () {
				state.onlyGroupLeaders = $(this).val();
			});
			filter();
		};

		var updateLocationFilter = function () {
			$('.politician-find-page__location-checkbox:checked').each(function () {
				state.selectedLocations.push($(this).val());
			});
			filter();
		};

		var updateGroupFilter = function () {

			$('.politician-find-page__group-checkbox:checked').each(function () {
				if (!$(this).data("isgroup"))
					state.selectedGroups.push($(this).val());
			});
			filter();
		};

		// Hook checkboxes
		$(".politician-find-page__party-checkbox").change(function () {
			state.selectedParties = [];
			updatePartyFilter();
		});
		
		$(".politician-find-page__group-leader-checkbox").change(function () {
			state.onlyGroupLeaders = $(this).prop("checked") ? "1" : "0";
			updateGroupLeaderFilter();
		});

		$(".politician-find-page__location-checkbox").change(function () {
			state.selectedLocations = [];
			updateLocationFilter();
		});

		$(".politician-find-page__group-checkbox").change(function () {
			state.selectedGroups = [];

			var cbState = $(this).prop("checked");
			var $liContainer = $(this).closest("li");
			var $ulChildren = $liContainer.children("ul");
			var $checkboxes = $ulChildren.find(".politician-find-page__group-checkbox");

			// Check if there is sub categories
			if ($ulChildren.length >= 1 && $checkboxes.length >= 1) {

                if (cbState === true) {
                    $ulChildren.show();
                } else {
                    $ulChildren.hide();
				}

				// Do not check all sub checkboxes, if one is already checked
                var oneCbIsAlreadyChecked = false;
				$checkboxes.each(function () { if ($(this).prop('checked')) { oneCbIsAlreadyChecked = true; return false; } });
				if (!oneCbIsAlreadyChecked || cbState === false) {
                    $checkboxes.prop("checked", cbState);
                }
            } else {
				// Check if parent is checked
                var group = $(this).data("group");
				var $groupCb = $(".politician-find-page__group-checkbox[data-isgroup='true'][value='" + group + "']");
				if (!$groupCb.prop("checked")) {
                    $groupCb.prop("checked", true).change();
                }
            }

			updateGroupFilter();
		});

		// Hook search input query
		$(".search-filter-query").on("input", function () {
			state.query = $(this).val();
			filter();
		});

		// Prevent form submit
		$(".politician-find-page__filter .form").submit(function (e) {
			e.preventDefault();
		});

		// On load
		if (state.query !== "" || state.selectedParties.length > 0 || state.selectedLocations.length > 0 || state.selectedGroups.length > 0 || state.onlyGroupLeaders > 0) {
			filter();
			$(".search-filter-query").val(state.query);
			$(state.selectedParties).each(function (index, value) {
				$('.politician-find-page__party-checkbox[value="' + value + '"]').attr("checked", "checked");
			});
			$(state.selectedLocations).each(function (index, value) {
				$('.politician-find-page__location-checkbox[value="' + value + '"]').attr("checked", "checked");
			});
			$(state.selectedGroups).each(function (index, value) {
				$('.politician-find-page__group-checkbox[value="' + value + '"]').attr("checked", "checked").change();
			});
			if (state.onlyGroupLeaders === "1") {
				$('.politician-find-page__group-leader-checkbox').attr("checked", "checked").change();
			}
		}

		// Categories show/hide
		$(".politician-find-page__filter__toggler, .politician-find-page__filter__content .btn").click(function () {
			$(".politician-find-page__filter__toggle").toggleClass("politician-find-page__filter__toggle--expanded");
			$(".politician-find-page__filter__toggler").toggleClass("politician-find-page__filter__toggler--expanded");
			$('html, body').animate({
				scrollTop: $(".politician-find-page__filter__toggler").offset().top
			}, 200);
		});

		// Toggle show/hide politician
		$('.js-politician-link').click(function (e) {
			e.preventDefault();

			$('.js-politician-link.open').removeClass('open');
			$(this).toggleClass('open');
		});

		$('.js-politician-close').click(function () {
			var $politicionLink = $(this).parent().prev();
			$politicionLink.removeClass('open');
		});

		$('.politician-contact-card__memberships__toggle').click(function () {
			$(this).toggleClass('politician-contact-card__memberships__toggle__open');

			if ($('.politician-contact-card__memberships__toggle').hasClass('politician-contact-card__memberships__toggle__open')) {
				$('.politician-contact-card__memberships__toggle').text($(this).data("open"))
			} else {
				$('.politician-contact-card__memberships__toggle').text($(this).data("closed"))
			}

			$('.politician-contact-card__memberships__container').toggle();
		});

		$('#politician-find-page__filter__groups__checkboxes__toggle').click(function () {
			$('.politician-find-page__filter__groups__checkboxes__group').toggleClass('politician-find-page__filter__groups__checkboxes__group__limit');

			if ($('.politician-find-page__filter__groups__checkboxes__group').hasClass('politician-find-page__filter__groups__checkboxes__group__limit')) {
				$(this).text($(this).data("open"))
			} else {
				$(this).text($(this).data("closed"))
			}

		});

		$('#politician-find-page__filter__groups__checkboxes__toggle__external').click(function () {
			$('.politician-find-page__filter__groups__checkboxes__group__external').toggleClass('politician-find-page__filter__groups__checkboxes__group__limit');

			if ($('.politician-find-page__filter__groups__checkboxes__group__external').hasClass('politician-find-page__filter__groups__checkboxes__group__limit')) {
				$(this).text($(this).data("open"))
			} else {
				$(this).text($(this).data("closed"))
			}

		});
	}


})(jQuery);
